
import * as React from 'react'
import { WeikeAlertDemo } from './alert';
import { Dialog } from './dialog'
import { Toast } from './toast'
import { TopTips } from './toptip'
import { Mask } from './mask-layer'
import  DatePicker  from '../date-picker/index'

export function WeikeUIPopupLayer(rootComponent: React.ReactElement) {

  return (
    <>
      { rootComponent }
      <WeikeAlertDemo />
      <Dialog />
      <Toast />
      <TopTips />
      <Mask />
      <DatePicker/>
    </>
  )
}



// WEBPACK FOOTER //
// ../src/popup-layer/index.tsx